/**
 * Shared rate limiting utilities for the Baakas application
 * Consolidates duplicate rate limiting classes across components
 */

// Security: Rate limiting for component operations
export class ComponentRateLimiter {
  private attempts: Map<string, number[]> = new Map();
  private readonly maxAttempts: number = 5;
  private readonly timeWindow: number = 60000; // 1 minute

  isAllowed(operation: string, component: string = 'default'): { allowed: boolean; message?: string } {
    const key = `${component}:${operation}`;
    const now = Date.now();
    const recentAttempts = (this.attempts.get(key) || []).filter(
      timestamp => now - timestamp < this.timeWindow
    );

    if (recentAttempts.length >= this.maxAttempts) {
      return { 
        allowed: false, 
        message: `Rate limit exceeded for ${operation} in ${component}` 
      };
    }

    recentAttempts.push(now);
    this.attempts.set(key, recentAttempts);
    return { allowed: true };
  }

  // Clear attempts for a specific operation
  clear(operation: string, component: string = 'default'): void {
    const key = `${component}:${operation}`;
    this.attempts.delete(key);
  }

  // Clear all attempts
  clearAll(): void {
    this.attempts.clear();
  }
}

// Global rate limiter instance
export const globalRateLimiter = new ComponentRateLimiter();
